import { syncHistoryWithStore } from 'react-router-redux';

import { store } from 'Internals/store';
import { browserHistory } from 'Internals/browserHistory';

// Create an enhanced history that syncs navigation events with the store
export const history = syncHistoryWithStore(browserHistory, store);
